<template>
  <base-button class="btn-secondary" :text="text" />
</template>
<script>
import BaseButton from "@/views/atoms/BaseButton";

export default {
  name: 'ChangeStatusButton',
  components: {
    BaseButton
  },
  props: {
    text: {
      type: String,
      required: true,
    }
  }
}
</script>
